import React from "react";
import "./Modal.scss";

export default function Modal(props) {
  return (
    <div className="modal__div">
      <div className="modal">
        <div className="modal__top">
          <h3 className="title">New Feature: Conversion Intelligence</h3>
          <button
            className="modal__close-icon"
            onClick={() => props.setModal(false)}
          >
            {" "}
          </button>
        </div>
        <div className="modal__mid">
          Machine learning and AI insights let you predict visitor behavior
          ahead of time so you can launch campaigns that’re more relevant to
          your audience—right from the get-go. This means lower ad costs and an
          average conversion rate increase of over 30%.
        </div>
        <div className="modal__bottom">
          <button className="modal__learn">Learn More</button>
          <button className="modal__next" onClick={() => props.setModal(false)}>
            {" "}
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
}
